// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4475":"2d877a87","6211":"2a028ab3","8130":"48c8fd76","8300":"a8600284"}[chunkId] + ".chunk.css";
};